// This is a our new theme file, named Dagstorp for job security purposes.
// Once our deprecated Theme.js file is no longer used we will rename.

const BASE_FONT_SIZE = 16; // 16px
const BASE_SPACING = 8; // 8px

const toPx = multiplier => `${multiplier * BASE_SPACING}px`;

const borderRadius = {
  small: '4px',
  medium: '16px',
  large: '20px',
  circular: '50%',
};

const colors = {
  brand: {
    primary: 'rgb(186, 237, 230)',
    primaryVariant1: 'rgb(227, 247, 246)',
    secondary: 'rgb(102, 133, 125)',
  },
  environment: {
    divider: 'rgba(23, 82, 74, 0.17)',
    surface: 'rgb(255, 255, 255)',
    icon: 'rgb(23, 82, 74)',
  },
  text: {
    primary: 'rgb(23, 82, 74)',
    secondary: 'rgba(23, 82, 74, 0.75)',
    primaryOnDark: 'rgba(255,255,255)',
    warning: 'rgb(255,77,0)',
    success: 'rgb(0,178,153)',
  },
};

const spacing = [
  0,
  toPx(1),
  toPx(2),
  toPx(3),
  toPx(4),
  toPx(5),
  toPx(6),
  toPx(7),
  toPx(8),
  toPx(9),
  toPx(10),
  toPx(11),
  toPx(12),
  toPx(13),
  toPx(14),
  toPx(15),
];

const icons = {
  default: '24px',
  medium: '32px',
  large: '48px',
  xlarge: '72px',
};

const typography = {
  h1: {
    fontFamily: '"Intro", sans-serif',
    fontSize: '96px',
    fontWeight: '300',
    letterSpacing: `${-1.5 / BASE_FONT_SIZE}em`,
    lineHeight: '1',
  },
  h2: {
    fontFamily: '"Intro", sans-serif',
    fontSize: '60px',
    fontWeight: '300',
    letterSpacing: `${-0.5 / BASE_FONT_SIZE}em`,
    lineHeight: '1',
  },
  h3: {
    fontFamily: '"Intro", sans-serif',
    fontSize: '48px',
    fontWeight: '300',
    letterSpacing: 'default',
    lineHeight: '1.04',
  },
  h4: {
    fontFamily: '"Intro", sans-serif',
    fontSize: '34px',
    fontWeight: '300',
    letterSpacing: `${0.25 / BASE_FONT_SIZE}em`,
    lineHeight: '1.17',
  },
  h5: {
    fontFamily: '"Intro", sans-serif',
    fontSize: '24px',
    fontWeight: '300',
    letterSpacing: 'default',
    lineHeight: '1.333',
  },
  h6: {
    fontFamily: '"Intro", sans-serif',
    fontSize: '20px',
    fontWeight: '300',
    letterSpacing: `${0.15 / BASE_FONT_SIZE}em`,
    lineHeight: '1.6',
  },
  body1: {
    fontFamily: '"Assistant", sans-serif',
    fontSize: '16px',
    fontWeight: '300',
    letterSpacing: `${0.5 / BASE_FONT_SIZE}em`,
    lineHeight: '1.5',
  },
  body2: {
    fontFamily: '"Assistant", sans-serif',
    fontSize: '14px',
    fontWeight: '300',
    letterSpacing: `${0.25 / BASE_FONT_SIZE}em`,
    lineHeight: '1.43',
  },
  subtitle1: {
    fontFamily: '"Assistant", sans-serif',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: `${0.15 / BASE_FONT_SIZE}em`,
    lineHeight: '1.5',
  },
  subtitle2: {
    fontFamily: '"Assistant", sans-serif',
    fontSize: '14px',
    fontWeight: '300',
    letterSpacing: `${0.1 / BASE_FONT_SIZE}em`,
    lineHeight: '1.57',
  },
  button: {
    fontFamily: '"Intro", sans-serif',
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: `${1.25 / BASE_FONT_SIZE}em`,
  },
  caption: {
    fontFamily: '"Assistant", sans-serif',
    fontSize: '12px',
    fontWeight: '300',
    letterSpacing: `${0.4 / BASE_FONT_SIZE}em`,
    lineHeight: '1.333',
  },
  overline: {
    fontFamily: '"Assistant", sans-serif',
    fontSize: '10px',
    fontWeight: '500',
    letterSpacing: `${1.5 / BASE_FONT_SIZE}em`,
    lineHeight: '3.2',
  },
};

const avatar = {
  small: '24px',
  medium: '1.333',
  large: '56',
};

const boxShadow = {
  paper: 'box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  modal: 'box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
  popupMenu: 'box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
};


export default {
  avatar,
  BASE_FONT_SIZE,
  borderRadius,
  boxShadow,
  colors,
  icons,
  spacing,
  typography,
};
